/* eslint-disable no-use-before-define */
import { Map } from 'immutable';

import { ApiActions } from '../../constants/ApiActions';
import { createReducer } from '../../lib/ReducerUtils';

const INITIAL_STATE = Map({});

// COMPOSERS ENTITY REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.FETCH_COMPOSER_SUCCESS]: saveComposerData,
});

// CASE FUNCTIONS

function saveComposerData(state, action) {
  return state.mergeDeep(action.response.entities.composers);
}
